import React from 'react';
import { Link } from 'react-router-dom';
import Bg from '../../images/shapes/shape_title_under_line.svg'
import circle1 from '../../images/hero/circle_engine_1.webp'
import circle2 from '../../images/hero/circle_engine_2.webp'
import circle3 from '../../images/hero/circle_engine_3.webp'
import circle4 from '../../images/hero/circle_engine_4.webp'
import shape1 from '../../images/hero/shape_image_1.webp'
import shape2 from '../../images/hero/shape_image_2.webp'
import shape3 from '../../images/hero/shape_image_3.webp'
import shape4 from '../../images/hero/shape_image_4.webp'
import malaysiaFlag from '../../images/flags/malaysia.svg'
import singaporeFlag from '../../images/flags/singapore.svg'
import indiaFlag from '../../images/flags/india.svg'
import australiaFlag from '../../images/flags/australia.svg'
import uaeFlag from '../../images/flags/uae.svg'
import ksaFlag from '../../images/flags/ksa.svg'

const servingCountries = [
    { name: 'Malaysia', text: 'MALAYSIA', flag: malaysiaFlag, angle: 0, target: '/contact#office-malaysia' },
    { name: 'Singapore', text: 'SINGAPORE', flag: singaporeFlag, angle: 60, target: '/contact#office-singapore' },
    { name: 'India', text: 'INDIA', flag: indiaFlag, angle: 120, target: '/contact#office-india' },
    { name: 'Australia', text: 'AUSTRALIA', flag: australiaFlag, angle: 180, target: '/contact#office-australia' },
    { name: 'UAE', text: 'UAE', flag: uaeFlag, angle: 240, target: '/contact#office-uae' },
    { name: 'KSA', text: 'KSA', flag: ksaFlag, angle: 300, target: '/contact#office-ksa' },
];

const Hero2 = (props) => {

    return (

        <section className="software_company_hero_section xb-hidden">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="content_wrap">
                            <div className="heading_focus_text has_underline d-inline-flex" style={{ backgroundImage: `url(${Bg})` }}>
                                Perfect Company Solution
                            </div>
                            <h1>
                                We Build Reliable <mark>IT Solutions</mark> for Growing Businesses.
                            </h1>
                            <p>
                                Krit Cloud Platforms Sdn Bhd helps businesses modernize with cloud, software, data, cybersecurity and automation solutions built for practical growth.
                            </p>
                            <ul className="step_list unordered_list_block">
                                <li>Focus on quality first</li>
                                <li>Get to the market on time</li>
                            </ul>
                            <ul className="btns_group unordered_list p-0 justify-content-start">
                                <li>
                                    <Link className="btn" to="/contact">
                                        <span className="btn_label" data-text="Contact Us Today!">Contact Us Today!</span>
                                        <span className="btn_icon">
                                            <i className="fa-solid fa-arrow-up-right"></i>
                                        </span>
                                    </Link>
                                </li>
                                <li>
                                    <a className="hotline_block" href="tel:+60149125018">
                                        <span className="hotline_icon">
                                            <i className="fa-solid fa-phone-volume"></i>
                                        </span>
                                        <span className="hotline_content">
                                            <small>CONTACT US DAILY</small>
                                            <strong>+60 14-912 5018</strong>
                                        </span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="engine_image">
                            <div className="image_wrap_1">
                                <img src={circle1} alt="Engine" />
                            </div>
                            <div className="image_wrap_2">
                                <img src={circle2} alt="Engine" />
                            </div>
                            <div className="image_wrap_3">
                                <img src={circle3} alt="Engine" />
                            </div>
                            <div className="image_wrap_4">
                                <img src={circle4} alt="Engine" />
                            </div>
                            <ul className="hero_country_orbit unordered_list">
                                {servingCountries.map((country) => (
                                    <li
                                        key={country.name}
                                        style={{
                                            '--country-angle': `${country.angle}deg`,
                                            '--country-angle-reverse': `${country.angle * -1}deg`,
                                        }}
                                    >
                                        <Link to={country.target} aria-label={`View ${country.name} contact details`}>
                                            <svg className="country_curve_text" viewBox="0 0 100 100" aria-hidden="true">
                                                <defs>
                                                    <path id={`countryTextPath-${country.name}`} d="M 18 54 A 32 32 0 0 1 82 54" />
                                                </defs>
                                                <text>
                                                    <textPath href={`#countryTextPath-${country.name}`} startOffset="50%" textAnchor="middle">
                                                        {country.text}
                                                    </textPath>
                                                </text>
                                            </svg>
                                            <span className="country_name">{country.name}</span>
                                            <span className="country_flag_badge">
                                                <img src={country.flag} alt={`${country.name} service region`} />
                                            </span>
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="shape_image_1">
                <img src={shape1} alt="Engine" />
            </div>
            <div className="shape_image_2">
                <img src={shape2} alt="Engine" />
            </div>
            <div className="shape_image_3">
                <img src={shape3} alt="Engine" />
            </div>
            <div className="shape_image_4">
                <img src={shape4} alt="Engine" />
            </div>
        </section>
    )
}

export default Hero2;
